import React from 'react';
import Embedo from 'embedo';

const SUPPORTED_NETWORKS_REGEXES = {
  facebook: /(?:(?:http|https):\/\/)?(?:www.)?facebook.com/,
  twitter: /^http[s]*:\/\/[www.]*twitter(\.[a-z]+).*/i,
  instagram: /(http|https)?:\/\/(www\.)?instagram.com\/p\/[a-zA-Z0-9_\/\?\-\=]+/gi,
  youtube: /^(?:(?:https?:)?\/\/)?(?:www\.)?(?:m\.)?(?:youtu(?:be)?\.com\/(?:v\/|embed\/|watch(?:\/|\?v=))|youtu\.be\/)((?:\w|-){11})(?:\S+)?$/,
  vimeo: /(http|https)?:\/\/(www\.)?vimeo(\.[a-z]+)\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/,
  github: /(http|https):\/\/gist\.github\.com\/(\w+)\/(\w+)/,
};

export const isEmbeddableLink = link =>
  Object.values(SUPPORTED_NETWORKS_REGEXES).reduce(
    (isPresent, instanceTest) => (isPresent ? isPresent : instanceTest.test(link)),
    false
  );

class EmbeddedLink extends React.PureComponent {
  container = React.createRef();
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const embedo = new Embedo({
      facebook: {
        version: 'v2.10',
        appId: '444236643102167',
      },
      twitter: true,
      instagram: true,
      pinterest: true,
    });
    embedo.load(this.container.current, this.props.href);
  }

  render() {
    return <a href={this.props.href} target="_blank" ref={this.container} />;
  }
}

export default EmbeddedLink;
